import { useState } from 'react'
import Icon from '../Icons/Icons'
import TextBox from '../Textboxs/Textbox'
import CheckBox from './CechkBox'
import Button from '../Buttons/Button'
import { Backdrop } from '../../Components'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import Debounce from '../Textboxs/Debounce'

const CheckBoxGroup = ({
  items,
  lable,
  name,
  isRequired,
  onChange,
}: CheckBoxGroupInterface) => {
  const [showCheckBoxs, setShowCheckBoxs] = useState(false)
  var itemsSelected = {}
  const arrSelected = Object.entries(items!).filter((n) => n[1].checked)
  arrSelected.forEach((n) => {
    itemsSelected[n[0]] = n[1]
  })
  const [selectedCheckBox, setSelectedCheckBox] = useState<
    { [id: string]: CheckBoxInterface } | undefined
  >(itemsSelected ?? {})

  const chnageCheckBox = (e) => {
    if (selectedCheckBox![e.currentTarget.value])
      delete selectedCheckBox![e.currentTarget.value]
    else {
      selectedCheckBox![e.currentTarget.value] = {
        lable: items![e.currentTarget.value].lable,
        value: e.currentTarget.value,
      }
    }

    setSelectedCheckBox(selectedCheckBox)
  }
  return (
    <>
      <div className='relative w-full '>
        <TextBox
          Type={TextBoxTypeEnum.Text}
          isRequired={isRequired}
          name={name}
          innerText={lable}
          raytebValue={Object.getOwnPropertyNames(selectedCheckBox)
            .map((n) => selectedCheckBox![n].value)
            .join(',')}
          isReadOnly={true}
          className='w-full pl-7 '
          value={Object.getOwnPropertyNames(selectedCheckBox)
            .map((n) => selectedCheckBox![n].lable)
            .join(',')}
          onFocus={() => {
            setShowCheckBoxs(!showCheckBoxs)
          }}
        />
        <Icon
          icon='rayteb-android-more-vertical'
          className='absolute top-[35%] left-2 w-4 h-4 text-xl'
          onClick={() => setShowCheckBoxs(true)}
        />
      </div>
      <div
        className={`${
          showCheckBoxs ? 'fixed' : 'hidden'
        }  left-[50%] right-[50%] translate-x-[50%] translate-y-[50%] 
             z-50 bg-white rounded-lg shadow w-64 overflow-hidden `}
      >
        <span className='w-full text-sm flex justify-center items-center border-b border-primaryDefault2 py-2'>
          {lable}
        </span>
        <ul className='h-48 px-3 py-3 overflow-y-auto text-sm text-gray-700 flex flex-col gap-2 '>
          {Object.getOwnPropertyNames(items).map((n, i) => (
            <li key={i}>
              <CheckBox
                checked={items![n].checked ?? false}
                value={items![n].value ?? n}
                lable={items![n].lable}
                onChange={chnageCheckBox}
              />
            </li>
          ))}
        </ul>
        <Button
          onClick={() => {
            setShowCheckBoxs(false)
            Debounce({ func: () => onChange?.(), timeout: 400 })
          }}
          className='!w-full bg-primaryLight !px-0 !rounded-none text-white   h-8'
        >
          تایید
        </Button>
      </div>
      {showCheckBoxs ? (
        <Backdrop
          onClick={() => {
            // setShowCheckBoxs(false)
          }}
        />
      ) : (
        ''
      )}
    </>
  )
}

export default CheckBoxGroup
